<ng-template #OrgBreadcrumb>
  <cso-breadcrumb-tooltip
    [parentOrganizationTree]="parentOrganizationTree"
  ></cso-breadcrumb-tooltip>
</ng-template>

<div fxLayout="column" style="padding-right: 10px">
  <div
    fxLayout="row"
    fxHide.lt-md="true"
    fxShow="true"
    fxLayoutAlign="end center"
    class="header-row-container"
  >
    <span *ngIf="(userProfileData$ | async).firstName; else noFirstName" class="welcomeHeader" nowrap fxFlex="20%"
      >{{ "Header.Welcome" | translate }}, {{ (userProfileData$ | async).firstName }}</span
    >
    <ng-template #noFirstName>
      <span *ngIf="!(userProfileData$ | async).firstName" class="welcomeHeader" nowrap fxFlex="20%"
      >{{ "Header.Welcome" | translate }}!</span
    >
    </ng-template>

     <global-tank-search fxFlex="30%"></global-tank-search>
     <span placement="bottom" fxLayoutAlign="right center" class="orgBreadCrumb" [ngClass]="{'pill hoverable ': !themeEnabled}"

    maxWidth="600px"
    contentType="template"
    placement="bottom"
    show-delay="500"
    hide-delay="500"
    content-type="template">
      <a style="font:bold;" [hidden]="themeEnabled" href="https://app.five9.com/consoles/ChatConsole/index.html?title=Skybitz%20Telemetry%20Support%20Chat&tenant=Telular&profiles=CHT_Tank&showProfiles=true&autostart=true&theme=default-theme.css&surveyOptions=%7B%22showComment%22%3Atrue%2C%22requireComment%22%3Afalse%7D&fields=%7B%22name%22%3A%7B%22value%22%3A%22%22%2C%22show%22%3Atrue%2C%22label%22%3A%22Name%22%7D%2C%22email%22%3A%7B%22value%22%3A%22%22%2C%22show%22%3Atrue%2C%22label%22%3A%22Email%22%7D%2C%22UserLocale%22%3A%7B%22value%22%3A%22en%22%2C%22show%22%3Afalse%7D%7D&playSoundOnMessage=true&allowCustomerToControlSoundPlay=false&showEmailButton=false&useBusinessHours=false&showPrintButton=false&allowUsabilityMenu=false&enableCallback=false&callbackList=&allowRequestLiveAgent=false" target="_blank"
      class="tooltip-container" title="Click to chat with SmartTank Customer Support and a new tab will open.
      Agents are available during the following working hours:
      Monday‐Friday: 7:30am – 6:30pm EST (except for holidays)">
      <i class="fa-2x fa-solid fa-message"></i>
      <span class="tooltip-text">Chat with tech support</span>
    </a>
    </span>
    <span (click)="copyText()" class="pill hoverable" placement="bottom" fxLayoutAlign="left center"
    [tooltip]="tooltipText"><i class="fa-2x fa-solid fa-copy"></i></span>
    <span id="textToCopy" style="display: none;">{{copyOrgTree}}</span>

    <span
      class="pill hoverable"
      fxLayoutAlign="right center"
      [tooltip]="OrgBreadcrumb"
      maxWidth="600px"
      contentType="template"
      placement="bottom"
      show-delay="500"
      hide-delay="500"
      tooltip-class="csoToolTip"
      content-type="template"
    >
      <svg-icon
        src="assets/svg/org-circle.svg"
        class="themed-svg-icon"
      ></svg-icon>
      <span
        siteUsageTracker
        [logCategory]="'TankSearch'"
        (click)="openCSODialog()"
        [logName]="'csoChooser'"
        class="user-profile"
        >{{ (userProfileData$ | async)?.lastSelectedOrganizationName }}</span
      >
    </span>
    <span
      class="pill hoverable"
      fxLayoutAlign="left center"
      #menuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="userProfile"
      [matTooltip]="'Header.LoggedInAs' | translate"
    >
      <i
        class="fa fa-user-circle"
        style="font-size: 30px"
        aria-hidden="true"
      ></i>
      <span>{{ (userProfileData$ | async)?.userName }}</span>
    </span>

    <span
      *ngIf="!showBuildInfo"
      class="pill hoverable"
      fxLayoutAlign="left center"
    >
      <svg-icon src="assets/svg/help.svg" class="tap-themeable"></svg-icon>
    </span>

    <span
      *ngIf="showBuildInfo"
      class="pill hoverable"
      fxLayoutAlign="left center"
      #menuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="helpMenu"
    >
      <svg-icon src="assets/svg/help.svg" class="tap-themeable"></svg-icon>
    </span>
  </div>
</div>

<mat-menu #userProfile="matMenu" siteUsageTracker [logCategory]="'LogOut'">
  <div (click)="myAccount()" siteUsageTracker [logCategory]="'MyAccount'" mat-menu-item>
    {{ "Header.MyAccount" | translate }}
  </div>
  <div (click)="logout()" siteUsageTracker [logCategory]="'LogOut'" mat-menu-item>
    {{ "Header.Logout" | translate }}
  </div>
</mat-menu>

<mat-menu #helpMenu="matMenu">
  <div
    mat-menu-item
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="buildInfoMenuItem"
  >
    <mat-checkbox (change)="onVersionCheckboxClick()">{{
      "Header.Version" | translate
    }}</mat-checkbox>
  </div>
</mat-menu>

<mat-menu #buildInfoMenuItem="matMenu" class="mxWidthNone">
  <mat-card>{{ buildInfo }}</mat-card>
</mat-menu>
